import { coveoConfig } from "../global/coveo-components";
import Util from "../global/util/util";

export interface CoveoToken {
	orgId: string,
	token: string
};
export class CoveoTokenService {

	public static getCoveoSearchToken(domain?: string): Promise<CoveoToken> {
		domain = domain ? domain : Util.getDomain();
		return new Promise(function (resolve, reject) {
			fetch(`//${domain}${coveoConfig.tokenUrl}`, {
				cache: 'no-store',
			})
			.then(function (response) {
				response.text()
					.then(function (text) {
						let coveoTokenResult = {
							orgId: response.headers.get('coveo.organizationId'),
							token: text
						};
						resolve(coveoTokenResult);
					});
			})
			.catch(function (error) {
				console.log('error retrieving the search token: ', error);
				reject(error);
			});
		});
	}
}
